import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import FloatingIcons from "./components/floating-icons/FloatingIcons";
import { AuthProvider } from "./context/AuthContext";
import { Helmet } from "react-helmet-async";

// Lazy-loaded pages — each loads only when navigated to
const Home = React.lazy(() => import("./pages/home/Home"));
const About = React.lazy(() => import("./pages/about/About"));
const ServicesPage = React.lazy(() => import("./pages/services/Services"));
const Areas = React.lazy(() => import("./pages/areas/Areas"));
const AreaDetails = React.lazy(() => import("./pages/areas/AreaDetails"));
const ArticlesPage = React.lazy(() => import("./pages/articles/Articles"));
const ArticleDetails = React.lazy(() => import("./pages/articles/ArticleDetails"));
const AdminDashboard = React.lazy(() => import("./pages/admin/AdminDashboard"));
const AdminLogin = React.lazy(() => import("./pages/admin/AdminLogin"));
const Contact = React.lazy(() => import("./pages/contact/Contact"));
const ProtectedRoute = React.lazy(() => import("./components/ProtectedRoute"));

// Minimal loading spinner shown while a lazy page chunk downloads
const PageLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
    direction: 'rtl'
  }}>
    <div style={{
      width: '40px',
      height: '40px',
      border: '4px solid rgba(253, 185, 19, 0.2)',
      borderTop: '4px solid #FDB913',
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite'
    }} />
  </div>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Helmet>
            <title>ونش انقاذ سيارات | خصم 50% | 01055557235 لنقل وإنقاذ جميع السيارات</title>
            <meta name="description" content="أسرع خدمة ونش انقاذ سيارات في مصر. ونش انقاذ متاح 24 ساعة لسحب السيارات المعطلة في جميع المحافظات." />
            <meta name="keywords" content="ونش انقاذ, ونش انقاذ سيارات, خدمة ونش, انقاذ سريع, رقم ونش انقاذ, اقرب ونش انقاذ, ونش انقاذ 24 ساعة, مصر" />
            <meta property="og:title" content="ونش انقاذ سيارات | خصم 50% | أسرع ونش انقاذ 24/7 | 01055557235" />
            <meta property="og:description" content="أسرع ونش انقاذ سيارات في مصر. ونش انقاذ متاح 24 ساعة لسحب السيارات المعطلة في جميع المحافظات." />
            <meta name="twitter:title" content="ونش انقاذ سيارات | خصم 50% | أسرع ونش انقاذ 24/7 | 01055557235" />
            <meta name="twitter:description" content="أسرع ونش انقاذ سيارات في مصر. ونش انقاذ متاح 24 ساعة لسحب السيارات المعطلة في جميع المحافظات." />
          </Helmet>
          <Header />
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/areas" element={<Areas />} />
              <Route path="/areas/:areaName" element={<AreaDetails />} />
              <Route path="/articles" element={<ArticlesPage />} />
              <Route path="/articles/:slug" element={<ArticleDetails />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Suspense>
          <Footer />
          <FloatingIcons />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
